function formatDate(dateString) {
  if (!dateString) {
    return "Date not available";
  }
  const date = new Date(dateString);
  const options = { day: "2-digit", month: "long", year: "numeric" };

  return date.toLocaleDateString("en-GB", options);
}

export default formatDate;
